export default __webpack_public_path__ + "img_220720_Women_at_Amazon_main_h_fullcolor_rgb.svg";